export enum SessionSatisfactionEnum {
    GOOD = 1, // 좋았어요
    NORMAL = 2, // 보통이에요
    BAD = 3, // 아쉬워요
}

export const sessionSatisfactionText = {
    [SessionSatisfactionEnum.GOOD]: '좋았어요',
    [SessionSatisfactionEnum.NORMAL]: '보통이에요',
    [SessionSatisfactionEnum.BAD]: '아쉬워요',
};
